exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auto-suggest-wrapper {\n  position: relative;\n  flex-grow: 1;\n}\n\n.auto-suggest-wrapper .react-autosuggest__suggestions-container--open {\n  border: 1px solid #c4cdd6;\n  width: 100%;\n  position: absolute;\n  max-height: 130px;\n  overflow: scroll;\n  background-color: white;\n  z-index: 1;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);\n}\n\n.react-autosuggest__suggestions-container--open ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.suggestion-item {\n  padding: 10px 20px;\n  overflow-x: hidden;\n}\n\n.suggestion-item:hover {\n  cursor: pointer;\n  background-color: #f8fafd;\n}", ""]);

// exports
